module.exports = __webpack_public_path__ + "static/media/medir-el-exito.ca01172b.svg";